import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { useState } from "react";
import { QuestionTechnologyFormValues } from "src/models/QuestionTechnology.model";
import { showToast } from "src/utils/showToaster";
import { object, string } from "yup";
import JobForm from "../Layout/QuestionTechnologyForm";
import { useAddQuestionTechnologyMutation } from "src/services/QuestionTechnologyServices";

type Props = {
  onClose: () => void;
};

const AddQuestionTechnologyFormWrapper = ({ onClose }: Props) => {
  const [saveNextChecked, setSaveNextChecked] = useState(true);

  const [addQuestionTechnology] = useAddQuestionTechnologyMutation();

  // Form Initial Values
  const initialValues: QuestionTechnologyFormValues = {
    category: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    category: string().required("Please enter technology"),

  });

  // Handle Submit
  const handleSubmit = (
    values: QuestionTechnologyFormValues,
    { setSubmitting, resetForm }: FormikHelpers<QuestionTechnologyFormValues>
  ) => {
    const formatedValue = {
      questionTechnology: values.category,
    };

    addQuestionTechnology(formatedValue).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          if (!saveNextChecked) {
            resetForm();
            onClose();
          }
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth='sm' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form className="h-full overflow-hidden contents">
            <JobForm
              formikProps={formikProps}
              onClose={onClose}
              formType="Add"
              setSaveNextChecked={setSaveNextChecked}
              saveNextChecked={saveNextChecked}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddQuestionTechnologyFormWrapper;
